//  El cliente de Supabase, y nada más.
//
//  Vive aparte de `nucleo.ts` para que las pruebas de pantalla (`tests/pantalla/`)
//  lo reemplacen por `cliente.mock.ts` con un alias de Vite y corran el núcleo
//  de verdad contra una base de mentira, sin duplicar utilerías (Paso 3).
//
//  Sólo lo importa `nucleo.ts`, que re-exporta `sb`.

import { createClient } from '@supabase/supabase-js';
import type { Database } from './tipos/supabase';

const SUPABASE_URL = 'https://flgvalwvzfbtwnhvpdmn.supabase.co';
const SUPABASE_KEY = 'sb_publishable_t0ZEahtjcds3Ul62L3CJ9A_9KHEdmAZ';

export const sb = createClient<Database>(SUPABASE_URL, SUPABASE_KEY);
